import React from "react";

/**
 * Pill radios for 2 to 5 short options (design ChoiceGroup). Native radios underneath, so keyboard and focus
 * work on their own; the first radio takes `id` so a field label or a validation error can point at it.
 */
export default function ChoiceGroup({ id, name, options, value, onChange, labelledBy, describedBy, invalid = false }) {
  return (
    <div
      className="crm-rollo__choices"
      role="radiogroup"
      aria-labelledby={labelledBy}
      aria-describedby={describedBy}
      aria-invalid={invalid || undefined}
    >
      {options.map((option, index) => {
        const checked = value === option.value;
        return (
          <label key={option.value} className={`crm-rollo__choice${checked ? " is-checked" : ""}`}>
            <input
              id={index === 0 ? id : undefined}
              type="radio"
              name={name}
              value={option.value}
              checked={checked}
              onChange={() => onChange(option.value)}
            />
            <span>{option.label}</span>
          </label>
        );
      })}
    </div>
  );
}
